import { SET_SPIN_COMPANY_ID } from '../types/spinPremiaTypes';

const initialState = {
  spin_company_id: ''
};

export default(state = initialState, action) => {
  switch (action.type) {
    case SET_SPIN_COMPANY_ID:
      return {
        ...state,
        spin_company_id: action.payload,
      };
    default:
      return state;
  }
}